import { render, staticRenderFns } from "./search-global.vue?vue&type=template&id=50492960&scoped=true"
import script from "./search-global.vue?vue&type=script&lang=js"
export * from "./search-global.vue?vue&type=script&lang=js"
import style0 from "./search-global.vue?vue&type=style&index=0&id=50492960&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50492960",
  null
  
)

export default component.exports